export class DisclaimerPageComponent implements ng.IComponentOptions {
  public controller: any = DisclaimerPageController;
  public template: string =
  `
    <div class="container container-fluid padding-2">
			<div class="row">
				<div class="col-md-12">
					<h1>Disclaimer</h1>
				</div>
			</div>
			<div class="row margin-bottom-40px">
				<div class="col-md-12">
					<p>The Malaysian Government shall not be liable for any loss or damage resulting from the use of information in this portal.</p>
				</div>
			</div>
		</div>
  `;
}

export class DisclaimerPageController {
  public static $inject: Array<string> = ['$anchorScroll'];
  constructor (private $anchorScroll: ng.IAnchorScrollService) {

  }

  public $onInit() {
    this.$anchorScroll();
  }
}
